import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsiteV2EnableEventFlagMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  flag: Types.Scalars['String'];
}>;

export type WebsiteV2EnableEventFlagMutation = { __typename?: 'Mutation'; createEventFeatureFlag: { __typename?: 'FeatureFlag'; id: string; flag: string } };

export type WebsiteV2DisableEventFlagMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  flag: Types.Scalars['String'];
}>;

export type WebsiteV2DisableEventFlagMutation = { __typename?: 'Mutation'; deleteEventFeatureFlag?: any | null };

export type WebsiteV2ApplyV1DesignMutationVariables = Types.Exact<{
  siteId: Types.Scalars['String'];
  purpose?: Types.InputMaybe<Types.CarbonWebsiteV1DesignPurpose>;
}>;

export type WebsiteV2ApplyV1DesignMutation = {
  __typename?: 'Mutation';
  carbonWebsiteApplyV1Design: {
    __typename?: 'CarbonWebsiteApplyV1DesignResult';
    site: { __typename?: 'CarbonWebsiteSite'; id: string };
    warnings: Array<{ __typename?: 'CarbonWebsiteV1DesignWarning'; code: string; token: string; detail: string }>;
  };
};

export type WebsiteV2V1DesignCompatibilityQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
  purpose?: Types.InputMaybe<Types.CarbonWebsiteV1DesignPurpose>;
}>;

export type WebsiteV2V1DesignCompatibilityQuery = {
  __typename?: 'Query';
  carbonWebsiteV1DesignCompatibility: {
    __typename?: 'CarbonWebsiteV1DesignCompatibility';
    supported: boolean;
    unsupported: Array<{ __typename?: 'CarbonWebsiteV1UnsupportedFeature'; code: string; label: string; detail: string; severity: Types.CarbonWebsiteV1CompatibilitySeverity }>;
  };
};

export type WebsiteV2SwitchTemplatesQueryVariables = Types.Exact<{
  kind?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type WebsiteV2SwitchTemplatesQuery = {
  __typename?: 'Query';
  carbonWebsiteTemplates: Array<{ __typename?: 'CarbonWebsiteTemplate'; id: string; name: string; kind: string; type: string; s3Folder: string; published: boolean }>;
};

export type WebsiteV2CreateSiteWithV1DesignMutationVariables = Types.Exact<{
  input: Types.CarbonWeddingWebsiteGenerateFromEventInput;
}>;

export type WebsiteV2CreateSiteWithV1DesignMutation = {
  __typename?: 'Mutation';
  carbonWeddingWebsiteGenerateFromEvent: {
    __typename?: 'CarbonWeddingWebsiteGenerateResult';
    runId: string;
    site: { __typename?: 'CarbonWeddingWebsiteSite'; id: string; name: string };
  };
};

export type WebsiteV2SwitchTargetSiteQueryVariables = Types.Exact<{
  siteId: Types.Scalars['String'];
}>;

export type WebsiteV2SwitchTargetSiteQuery = {
  __typename?: 'Query';
  carbonWebsiteSiteById?: {
    __typename?: 'CarbonWebsiteSite';
    id: string;
    published: boolean;
    theme?: { __typename?: 'CarbonWebsiteSiteTheme'; v1DesignAdaptable: boolean } | null;
  } | null;
};

export type WebsiteV2ExportDesignToV1MutationVariables = Types.Exact<{
  siteId: Types.Scalars['String'];
}>;

export type WebsiteV2ExportDesignToV1Mutation = {
  __typename?: 'Mutation';
  carbonWebsiteExportDesignToV1: {
    __typename?: 'CarbonWebsiteExportDesignToV1Result';
    published: boolean;
    warnings: Array<{ __typename?: 'CarbonWebsiteV1DesignWarning'; code: string; token: string; detail: string }>;
  };
};

export type WebsiteV2ExportDesignToV1PreviewQueryVariables = Types.Exact<{
  siteId: Types.Scalars['String'];
}>;

export type WebsiteV2ExportDesignToV1PreviewQuery = {
  __typename?: 'Query';
  carbonWebsiteExportDesignToV1Preview: {
    __typename?: 'CarbonWebsiteExportDesignToV1Result';
    unsupported: Array<{ __typename?: 'CarbonWebsiteV1UnsupportedFeature'; code: string; label: string; detail: string; severity: Types.CarbonWebsiteV1CompatibilitySeverity }>;
  };
};

export const WebsiteV2EnableEventFlagDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteV2EnableEventFlag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'flag' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEventFeatureFlag' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'flag' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'flag' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteV2EnableEventFlagMutationFn = Apollo.MutationFunction<WebsiteV2EnableEventFlagMutation, WebsiteV2EnableEventFlagMutationVariables>;

/**
 * __useWebsiteV2EnableEventFlagMutation__
 *
 * To run a mutation, you first call `useWebsiteV2EnableEventFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2EnableEventFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteV2EnableEventFlagMutation, { data, loading, error }] = useWebsiteV2EnableEventFlagMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      flag: // value for 'flag'
 *   },
 * });
 */
export function useWebsiteV2EnableEventFlagMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteV2EnableEventFlagMutation, WebsiteV2EnableEventFlagMutationVariables>,
) {
  return ApolloReactHooks.useMutation<WebsiteV2EnableEventFlagMutation, WebsiteV2EnableEventFlagMutationVariables>(WebsiteV2EnableEventFlagDocument, baseOptions);
}
export type WebsiteV2EnableEventFlagMutationHookResult = ReturnType<typeof useWebsiteV2EnableEventFlagMutation>;
export type WebsiteV2EnableEventFlagMutationResult = Apollo.MutationResult<WebsiteV2EnableEventFlagMutation>;
export type WebsiteV2EnableEventFlagMutationOptions = Apollo.BaseMutationOptions<WebsiteV2EnableEventFlagMutation, WebsiteV2EnableEventFlagMutationVariables>;
export const WebsiteV2DisableEventFlagDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteV2DisableEventFlag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'flag' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteEventFeatureFlag' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'flag' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'flag' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteV2DisableEventFlagMutationFn = Apollo.MutationFunction<WebsiteV2DisableEventFlagMutation, WebsiteV2DisableEventFlagMutationVariables>;

/**
 * __useWebsiteV2DisableEventFlagMutation__
 *
 * To run a mutation, you first call `useWebsiteV2DisableEventFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2DisableEventFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteV2DisableEventFlagMutation, { data, loading, error }] = useWebsiteV2DisableEventFlagMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      flag: // value for 'flag'
 *   },
 * });
 */
export function useWebsiteV2DisableEventFlagMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteV2DisableEventFlagMutation, WebsiteV2DisableEventFlagMutationVariables>,
) {
  return ApolloReactHooks.useMutation<WebsiteV2DisableEventFlagMutation, WebsiteV2DisableEventFlagMutationVariables>(WebsiteV2DisableEventFlagDocument, baseOptions);
}
export type WebsiteV2DisableEventFlagMutationHookResult = ReturnType<typeof useWebsiteV2DisableEventFlagMutation>;
export type WebsiteV2DisableEventFlagMutationResult = Apollo.MutationResult<WebsiteV2DisableEventFlagMutation>;
export type WebsiteV2DisableEventFlagMutationOptions = Apollo.BaseMutationOptions<WebsiteV2DisableEventFlagMutation, WebsiteV2DisableEventFlagMutationVariables>;
export const WebsiteV2ApplyV1DesignDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteV2ApplyV1Design' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'purpose' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CarbonWebsiteV1DesignPurpose' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteApplyV1Design' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'siteId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } } },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fromEvent' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [{ kind: 'ObjectField', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'purpose' } } }],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'site' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warnings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'detail' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteV2ApplyV1DesignMutationFn = Apollo.MutationFunction<WebsiteV2ApplyV1DesignMutation, WebsiteV2ApplyV1DesignMutationVariables>;

/**
 * __useWebsiteV2ApplyV1DesignMutation__
 *
 * To run a mutation, you first call `useWebsiteV2ApplyV1DesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2ApplyV1DesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteV2ApplyV1DesignMutation, { data, loading, error }] = useWebsiteV2ApplyV1DesignMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useWebsiteV2ApplyV1DesignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteV2ApplyV1DesignMutation, WebsiteV2ApplyV1DesignMutationVariables>) {
  return ApolloReactHooks.useMutation<WebsiteV2ApplyV1DesignMutation, WebsiteV2ApplyV1DesignMutationVariables>(WebsiteV2ApplyV1DesignDocument, baseOptions);
}
export type WebsiteV2ApplyV1DesignMutationHookResult = ReturnType<typeof useWebsiteV2ApplyV1DesignMutation>;
export type WebsiteV2ApplyV1DesignMutationResult = Apollo.MutationResult<WebsiteV2ApplyV1DesignMutation>;
export type WebsiteV2ApplyV1DesignMutationOptions = Apollo.BaseMutationOptions<WebsiteV2ApplyV1DesignMutation, WebsiteV2ApplyV1DesignMutationVariables>;
export const WebsiteV2V1DesignCompatibilityDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteV2V1DesignCompatibility' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'purpose' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CarbonWebsiteV1DesignPurpose' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteV1DesignCompatibility' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'purpose' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'supported' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unsupported' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'detail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteV2V1DesignCompatibilityQuery__
 *
 * To run a query within a React component, call `useWebsiteV2V1DesignCompatibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2V1DesignCompatibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteV2V1DesignCompatibilityQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useWebsiteV2V1DesignCompatibilityQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteV2V1DesignCompatibilityQuery, WebsiteV2V1DesignCompatibilityQueryVariables>,
) {
  return ApolloReactHooks.useQuery<WebsiteV2V1DesignCompatibilityQuery, WebsiteV2V1DesignCompatibilityQueryVariables>(WebsiteV2V1DesignCompatibilityDocument, baseOptions);
}
export function useWebsiteV2V1DesignCompatibilityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteV2V1DesignCompatibilityQuery, WebsiteV2V1DesignCompatibilityQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<WebsiteV2V1DesignCompatibilityQuery, WebsiteV2V1DesignCompatibilityQueryVariables>(WebsiteV2V1DesignCompatibilityDocument, baseOptions);
}
export type WebsiteV2V1DesignCompatibilityQueryHookResult = ReturnType<typeof useWebsiteV2V1DesignCompatibilityQuery>;
export type WebsiteV2V1DesignCompatibilityLazyQueryHookResult = ReturnType<typeof useWebsiteV2V1DesignCompatibilityLazyQuery>;
export type WebsiteV2V1DesignCompatibilityQueryResult = Apollo.QueryResult<WebsiteV2V1DesignCompatibilityQuery, WebsiteV2V1DesignCompatibilityQueryVariables>;
export const WebsiteV2SwitchTemplatesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteV2SwitchTemplates' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'kind' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteTemplates' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'kind' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'kind' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Folder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteV2SwitchTemplatesQuery__
 *
 * To run a query within a React component, call `useWebsiteV2SwitchTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2SwitchTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteV2SwitchTemplatesQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useWebsiteV2SwitchTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteV2SwitchTemplatesQuery, WebsiteV2SwitchTemplatesQueryVariables>) {
  return ApolloReactHooks.useQuery<WebsiteV2SwitchTemplatesQuery, WebsiteV2SwitchTemplatesQueryVariables>(WebsiteV2SwitchTemplatesDocument, baseOptions);
}
export function useWebsiteV2SwitchTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteV2SwitchTemplatesQuery, WebsiteV2SwitchTemplatesQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<WebsiteV2SwitchTemplatesQuery, WebsiteV2SwitchTemplatesQueryVariables>(WebsiteV2SwitchTemplatesDocument, baseOptions);
}
export type WebsiteV2SwitchTemplatesQueryHookResult = ReturnType<typeof useWebsiteV2SwitchTemplatesQuery>;
export type WebsiteV2SwitchTemplatesLazyQueryHookResult = ReturnType<typeof useWebsiteV2SwitchTemplatesLazyQuery>;
export type WebsiteV2SwitchTemplatesQueryResult = Apollo.QueryResult<WebsiteV2SwitchTemplatesQuery, WebsiteV2SwitchTemplatesQueryVariables>;
export const WebsiteV2CreateSiteWithV1DesignDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteV2CreateSiteWithV1Design' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CarbonWeddingWebsiteGenerateFromEventInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWeddingWebsiteGenerateFromEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'runId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'site' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteV2CreateSiteWithV1DesignMutationFn = Apollo.MutationFunction<WebsiteV2CreateSiteWithV1DesignMutation, WebsiteV2CreateSiteWithV1DesignMutationVariables>;

/**
 * __useWebsiteV2CreateSiteWithV1DesignMutation__
 *
 * To run a mutation, you first call `useWebsiteV2CreateSiteWithV1DesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2CreateSiteWithV1DesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteV2CreateSiteWithV1DesignMutation, { data, loading, error }] = useWebsiteV2CreateSiteWithV1DesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebsiteV2CreateSiteWithV1DesignMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteV2CreateSiteWithV1DesignMutation, WebsiteV2CreateSiteWithV1DesignMutationVariables>,
) {
  return ApolloReactHooks.useMutation<WebsiteV2CreateSiteWithV1DesignMutation, WebsiteV2CreateSiteWithV1DesignMutationVariables>(
    WebsiteV2CreateSiteWithV1DesignDocument,
    baseOptions,
  );
}
export type WebsiteV2CreateSiteWithV1DesignMutationHookResult = ReturnType<typeof useWebsiteV2CreateSiteWithV1DesignMutation>;
export type WebsiteV2CreateSiteWithV1DesignMutationResult = Apollo.MutationResult<WebsiteV2CreateSiteWithV1DesignMutation>;
export type WebsiteV2CreateSiteWithV1DesignMutationOptions = Apollo.BaseMutationOptions<WebsiteV2CreateSiteWithV1DesignMutation, WebsiteV2CreateSiteWithV1DesignMutationVariables>;
export const WebsiteV2SwitchTargetSiteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteV2SwitchTargetSite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteSiteById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'theme' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'v1DesignAdaptable' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteV2SwitchTargetSiteQuery__
 *
 * To run a query within a React component, call `useWebsiteV2SwitchTargetSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2SwitchTargetSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteV2SwitchTargetSiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useWebsiteV2SwitchTargetSiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteV2SwitchTargetSiteQuery, WebsiteV2SwitchTargetSiteQueryVariables>) {
  return ApolloReactHooks.useQuery<WebsiteV2SwitchTargetSiteQuery, WebsiteV2SwitchTargetSiteQueryVariables>(WebsiteV2SwitchTargetSiteDocument, baseOptions);
}
export function useWebsiteV2SwitchTargetSiteLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteV2SwitchTargetSiteQuery, WebsiteV2SwitchTargetSiteQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<WebsiteV2SwitchTargetSiteQuery, WebsiteV2SwitchTargetSiteQueryVariables>(WebsiteV2SwitchTargetSiteDocument, baseOptions);
}
export type WebsiteV2SwitchTargetSiteQueryHookResult = ReturnType<typeof useWebsiteV2SwitchTargetSiteQuery>;
export type WebsiteV2SwitchTargetSiteLazyQueryHookResult = ReturnType<typeof useWebsiteV2SwitchTargetSiteLazyQuery>;
export type WebsiteV2SwitchTargetSiteQueryResult = Apollo.QueryResult<WebsiteV2SwitchTargetSiteQuery, WebsiteV2SwitchTargetSiteQueryVariables>;
export const WebsiteV2ExportDesignToV1Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteV2ExportDesignToV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteExportDesignToV1' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'siteId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'publish' }, value: { kind: 'BooleanValue', value: true } },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'warnings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'detail' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteV2ExportDesignToV1MutationFn = Apollo.MutationFunction<WebsiteV2ExportDesignToV1Mutation, WebsiteV2ExportDesignToV1MutationVariables>;

/**
 * __useWebsiteV2ExportDesignToV1Mutation__
 *
 * To run a mutation, you first call `useWebsiteV2ExportDesignToV1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2ExportDesignToV1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteV2ExportDesignToV1Mutation, { data, loading, error }] = useWebsiteV2ExportDesignToV1Mutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useWebsiteV2ExportDesignToV1Mutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteV2ExportDesignToV1Mutation, WebsiteV2ExportDesignToV1MutationVariables>,
) {
  return ApolloReactHooks.useMutation<WebsiteV2ExportDesignToV1Mutation, WebsiteV2ExportDesignToV1MutationVariables>(WebsiteV2ExportDesignToV1Document, baseOptions);
}
export type WebsiteV2ExportDesignToV1MutationHookResult = ReturnType<typeof useWebsiteV2ExportDesignToV1Mutation>;
export type WebsiteV2ExportDesignToV1MutationResult = Apollo.MutationResult<WebsiteV2ExportDesignToV1Mutation>;
export type WebsiteV2ExportDesignToV1MutationOptions = Apollo.BaseMutationOptions<WebsiteV2ExportDesignToV1Mutation, WebsiteV2ExportDesignToV1MutationVariables>;
export const WebsiteV2ExportDesignToV1PreviewDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteV2ExportDesignToV1Preview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteExportDesignToV1Preview' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'siteId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unsupported' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'detail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteV2ExportDesignToV1PreviewQuery__
 *
 * To run a query within a React component, call `useWebsiteV2ExportDesignToV1PreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2ExportDesignToV1PreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteV2ExportDesignToV1PreviewQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useWebsiteV2ExportDesignToV1PreviewQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteV2ExportDesignToV1PreviewQuery, WebsiteV2ExportDesignToV1PreviewQueryVariables>,
) {
  return ApolloReactHooks.useQuery<WebsiteV2ExportDesignToV1PreviewQuery, WebsiteV2ExportDesignToV1PreviewQueryVariables>(WebsiteV2ExportDesignToV1PreviewDocument, baseOptions);
}
export function useWebsiteV2ExportDesignToV1PreviewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteV2ExportDesignToV1PreviewQuery, WebsiteV2ExportDesignToV1PreviewQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<WebsiteV2ExportDesignToV1PreviewQuery, WebsiteV2ExportDesignToV1PreviewQueryVariables>(
    WebsiteV2ExportDesignToV1PreviewDocument,
    baseOptions,
  );
}
export type WebsiteV2ExportDesignToV1PreviewQueryHookResult = ReturnType<typeof useWebsiteV2ExportDesignToV1PreviewQuery>;
export type WebsiteV2ExportDesignToV1PreviewLazyQueryHookResult = ReturnType<typeof useWebsiteV2ExportDesignToV1PreviewLazyQuery>;
export type WebsiteV2ExportDesignToV1PreviewQueryResult = Apollo.QueryResult<WebsiteV2ExportDesignToV1PreviewQuery, WebsiteV2ExportDesignToV1PreviewQueryVariables>;
